// Copyright (c) Meta Platforms, Inc. and affiliates.

'use client';

/**
 * @file InputClearButton.tsx
 * @input Uses React, Button, Icon
 * @output Exports InputClearButton, the shared clear (✕) button rendered by
 *   every clearable input in the family.
 * @position Shared primitive. Every input that renders a clear affordance —
 *   TextInput, NumberInput, TimeInput, DateInput, DateTimeInput,
 *   DateRangeInput, Selector, MultiSelector, Typeahead, Tokenizer, FileInput —
 *   routes it through here, so the glyph is themed in one place via the
 *   `astryx-input-clear-icon` target.
 */
import * as stylex from '@stylexjs/stylex';
import { Button } from "../Button/index.js";
import { Icon } from "../Icon/index.js";
import { themeProps } from "../utils/themeProps.js";
import { jsx as _jsx } from "react/jsx-runtime";
const styles = {
  button: {
    kZKoxP: "x1qx5ct2",
    kmuXW: "x2lah0s",
    $$css: true
  }
};
export function InputClearButton({
  label,
  onClick,
  xstyle,
  iconClassName
}) {
  const {
    className: iconTargetClassName
  } = themeProps('input-clear-icon');
  return /*#__PURE__*/_jsx(Button, {
    variant: "ghost",
    size: "sm",
    label: label,
    icon: /*#__PURE__*/_jsx(Icon, {
      icon: "close",
      size: "sm",
      color: "secondary",
      className: iconClassName != null ? `${iconTargetClassName} ${iconClassName}` : iconTargetClassName
    }),
    onClick: onClick,
    isIconOnly: true,
    xstyle: [styles.button, xstyle]
  });
}
InputClearButton.displayName = 'InputClearButton';